
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'

// Create the root element
const rootElement = document.getElementById("root")!;
const root = createRoot(rootElement);

// Render the app
root.render(<App />);
